import { useEffect, useRef } from 'react';

export default function SplineBackground() {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    const hideSplineLogo = () => {
      if (iframeRef.current) {
        const iframe = iframeRef.current;
        const applyStyles = () => {
          try {
            const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
            if (iframeDoc) {
              // Remove elementos existentes
              const elementsToRemove = iframeDoc.querySelectorAll('.logo-container, .controls-container, [data-spline-uiblock="true"]');
              elementsToRemove.forEach(el => el.remove());

              // Adiciona estilos
              const style = iframeDoc.createElement('style');
              style.textContent = `
                .logo-container, .controls-container, [data-spline-uiblock="true"],
                div[style*="position: fixed"][style*="bottom: 16px"][style*="right: 16px"],
                div[style*="position: fixed"][style*="bottom: 0"][style*="right: 0"] {
                  display: none !important;
                  opacity: 0 !important;
                  visibility: hidden !important;
                  pointer-events: none !important;
                  width: 0 !important;
                  height: 0 !important;
                  position: absolute !important;
                  z-index: -9999 !important;
                  clip: rect(0 0 0 0) !important;
                  margin: -1px !important;
                  padding: 0 !important;
                  border: 0 !important;
                }
                body, canvas, div {
                  background: black !important;
                }
                canvas {
                  transform: scale(1.2) !important;
                }
              `;
              iframeDoc.head.appendChild(style);

              // Força o background e remove elementos periodicamente
              if (iframeDoc.body) {
                iframeDoc.body.style.backgroundColor = 'black';
                
                // Remove elementos periodicamente
                setInterval(() => {
                  elementsToRemove.forEach(el => el.remove());
                }, 100);
              }
            }
          } catch (error) {
            console.error('Error hiding Spline logo:', error);
          }
        };

        iframe.onload = applyStyles;
        applyStyles();

        // Tenta aplicar os estilos múltiplas vezes nos primeiros segundos
        const retryTimes = [100, 500, 1000, 2000, 3000];
        retryTimes.forEach(time => {
          setTimeout(applyStyles, time);
        });
      }
    };

    hideSplineLogo();
  }, []);

  return (
    <div className="fixed inset-0 z-0 bg-black overflow-hidden" style={{ backgroundColor: 'black' }}>
      <div className="absolute inset-0 bg-black" style={{ backgroundColor: 'black' }} />
      <div className="absolute inset-0 scale-125">
        <iframe
          ref={iframeRef}
          src="https://my.spline.design/meeet-5ce2cffd31f30a704ff19b1e1481c7fa/"
          frameBorder="0"
          width="100%"
          height="100%"
          className="absolute inset-0 bg-black scale-110"
          title="Background Animation"
          style={{ 
            pointerEvents: 'none', 
            backgroundColor: 'black',
            border: 'none',
            outline: 'none',
            transform: 'scale(1.2)',
            transformOrigin: 'center center'
          }}
        />
      </div>
    </div>
  );
}
